import React, { FC } from 'react'
import { NavText as NavTextComponent } from '@cse/ui'

import { NavTextProps } from './nav-text.types'

export const NavText: FC<NavTextProps> = (props) => {
  return <NavTextComponent {...props} />
}
